(() => {
  const accountUrl = window.linxAccountUrl;
  if (!accountUrl) return;
  document.querySelectorAll('.site-nav__icons').forEach(actions => {
    if (actions.querySelector('.linx-account-link')) return;
    const link = document.createElement('a');
    link.className = 'site-nav__link site-nav__link--icon linx-account-link';
    link.href = accountUrl;
    link.setAttribute('aria-label', 'Account');
    link.innerHTML = '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.5"></circle><path d="M4.5 21c.7-4.1 3.4-6.2 7.5-6.2s6.8 2.1 7.5 6.2"></path></svg><span class="icon__fallback-text">Account</span>';
    actions.insertBefore(link, actions.querySelector('.js-drawer-open-cart') || null);
  });
})();
